import * as React from 'react';
import { createPopper, } from '@popperjs/core';
import { Transition } from 'react-transition-group';
import Icon from '@telia-front/icon';
import { useLabels, } from '@telia-front/label-provider';
import { breakPoints } from '@telia-front/theme-provider';
const CONTAINER_MAX_WIDTH = 1224;
const HEADER_BREAK = breakPoints.lg;
const HeaderDropdown = (props) => {
    const labels = useLabels();
    return (React.createElement(HeaderDropdownInner, Object.assign({}, props, { labels: labels })));
};
export default HeaderDropdown;
class HeaderDropdownInner extends React.PureComponent {
    constructor(props) {
        super(props);
        this.content = null;
        this.element = null;
        this.popper = null;
        this.getTransforms = ({ state }) => {
            const reference = state.elements.reference.getBoundingClientRect();
            const popper = state.elements.popper.getBoundingClientRect();
            const documentWidth = document.documentElement ? document.documentElement.clientWidth : 0;
            const popperWidth = popper.width;
            const halfReferenceWidth = reference.width / 2;
            const referenceMiddle = reference.left + halfReferenceWidth;
            // Align popper center of screen
            const idealPopperLeft = referenceMiddle - (popperWidth / 2);
            const containerWidth = Math.min(CONTAINER_MAX_WIDTH, documentWidth - 60);
            // If popper is out of container bounds, bring it back in bounds
            const minLeft = (documentWidth - containerWidth) / 2;
            const maxLeft = minLeft + containerWidth - popperWidth;
            const popperLeft = Math.round(Math.max(minLeft, Math.min(idealPopperLeft, maxLeft)));
            const popperTop = Math.round(reference.bottom) + (typeof this.props.offsetY === 'undefined' ? 5 : this.props.offsetY);
            if (window.innerWidth < HEADER_BREAK || this.props.fullWidth) {
                return {
                    popperTransform: `translate(0, ${popperTop}px)`,
                };
            }
            return {
                popperTransform: `translate(${popperLeft}px, ${popperTop}px)`,
            };
        };
        this.close = (event) => {
            var _a;
            event === null || event === void 0 ? void 0 : event.preventDefault();
            (_a = this.props.reference) === null || _a === void 0 ? void 0 : _a.focus();
            if (this.props.onClose) {
                this.props.onClose();
            }
        };
        this.onKeyDown = (event) => {
            // Invoke this.props.onClose when user hits ESC key.
            if (event.key === 'Escape' || event.key === 'Esc') {
                this.close(event);
            }
            if (this.props.onKeyDown) {
                this.props.onKeyDown(event);
            }
        };
        this.handleEnter = () => {
            this.initPopper();
        };
        this.handleExited = () => {
            this.destroyPopper();
            if (this.props.onTransitionExited) {
                this.props.onTransitionExited();
            }
        };
        this.setElementRef = (element) => {
            this.element = element;
            if (this.props.elementRef) {
                this.props.elementRef(element);
            }
        };
        this.setContentRef = (element) => {
            this.content = element;
            if (this.props.contentRef) {
                this.props.contentRef(element);
            }
        };
        this.renderDropdown = (state) => {
            if (!this.state.isMounted) {
                return null;
            }
            return (React.createElement("div", { className: this.BEM(state), onKeyDown: this.onKeyDown, style: this.state.popperStyle, tabIndex: -1, ref: this.setElementRef, onMouseLeave: this.props.onMouseLeave, id: this.props.id },
                React.createElement("div", { className: "header__dropdown-inner" },
                    React.createElement("div", { className: "header__dropdown-content-wrapper", ref: this.setContentRef },
                        this.props.onClose && this.getCloseButton(),
                        this.props.header && (React.createElement("div", { className: "header__dropdown-header" }, this.props.header)),
                        React.createElement("div", { className: "header__dropdown-content" }, this.props.children),
                        this.props.footer && (React.createElement("div", { className: "header__dropdown-footer" }, this.props.footer))))));
        };
        this.onOutsideClick = this.onOutsideClick.bind(this);
        this.state = {
            isMounted: false,
            popperStyle: {},
        };
    }
    componentDidMount() {
        this.setState({
            isMounted: true,
        });
        document.addEventListener('mousedown', this.onOutsideClick);
    }
    componentWillUnmount() {
        this.destroyPopper();
        document.removeEventListener('mousedown', this.onOutsideClick);
    }
    componentDidUpdate(prevProps) {
        // Reinitiate popper to get correct position styles after trigger reference element change
        if (this.props.reference !== prevProps.reference || this.props.container !== prevProps.container || this.props.size !== prevProps.size) {
            this.destroyPopper();
            this.initPopper();
        }
    }
    onOutsideClick(event) {
        var _a, _b, _c;
        if (this.props.isShown && ((_a = this.content) === null || _a === void 0 ? void 0 : _a.offsetParent)) {
            const clickedOnTrigger = event.target instanceof Element && ((_b = this.props.reference) === null || _b === void 0 ? void 0 : _b.contains(event.target));
            const clickedOnContent = event.target instanceof Node && ((_c = this.content) === null || _c === void 0 ? void 0 : _c.contains(event.target));
            if (clickedOnTrigger || clickedOnContent) {
                return;
            }
            this.close();
        }
    }
    initPopper() {
        if (this.element && this.props.reference && !this.popper && this.props.container) {
            this.popper = createPopper(this.props.reference, this.element, {
                modifiers: [
                    { name: 'applyStyles', enabled: false },
                    {
                        name: 'updateState',
                        enabled: true,
                        phase: 'write',
                        requires: ['computeStyles'],
                        fn: ({ state }) => this.updatePopperState(state),
                    },
                    {
                        name: 'accountForSize',
                        enabled: true,
                        phase: 'beforeWrite',
                        requires: ['computeStyles'],
                        effect: ({ state }) => {
                            // Necessary so that dropdown content would scroll correctly
                            state.elements.popper.style.height = `${this.getPopperHeight(state)}px`;
                        },
                        fn: ({ state }) => {
                            state.elements.popper.style.height = `${this.getPopperHeight(state)}px`;
                            if (state.elements.popper.classList.contains('header__nav-megamenu-dropdown')) {
                                state.elements.popper.style.background = `linear-gradient(to bottom, #f4f4f9 ${state.elements.popper.children[0].children[0].clientHeight}px, transparent 20px)`;
                            }
                            return state;
                        },
                    },
                    {
                        name: 'accountForCentering',
                        enabled: true,
                        phase: 'beforeWrite',
                        requires: ['computeStyles'],
                        fn: (data) => {
                            const { popperTransform } = this.getTransforms(data);
                            data.state.styles.popper.transform = popperTransform;
                            if (window.innerWidth < HEADER_BREAK) {
                                data.state.styles.popper.right = '0';
                                data.state.styles.popper.bottom = '0';
                            }
                            return data.state;
                        },
                    },
                    {
                        name: 'flip',
                        enabled: false,
                    },
                    {
                        name: 'preventOverflow',
                        options: {
                            padding: window.innerWidth < HEADER_BREAK ? 0 : 30,
                            boundariesElement: this.props.container,
                        },
                    },
                ],
                placement: 'bottom',
                strategy: 'fixed',
            });
        }
    }
    updatePopperState(state) {
        const popperStyle = Object.assign({}, state.styles.popper);
        this.setState({
            popperStyle,
        });
    }
    getPopperHeight(state) {
        const reference = state.elements.reference.getBoundingClientRect();
        const popperTop = Math.round(reference.bottom) + (typeof this.props.offsetY === 'undefined' ? 5 : this.props.offsetY);
        return window.innerHeight - popperTop;
    }
    destroyPopper() {
        if (this.popper) {
            this.popper.destroy();
            this.popper = null;
        }
    }
    get padding() {
        const { padded, padding } = this.props;
        if (padding) {
            return padding;
        }
        if (padded) {
            return 'medium';
        }
        return 'none';
    }
    BEM(state) {
        const classArray = [
            'header__dropdown',
            `header__dropdown--padding-${this.padding}`,
            'is-' + state,
        ];
        if (this.props.size) {
            classArray.push('header__dropdown--' + this.props.size);
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    getCloseButton() {
        const { closeButtonLabel, labels, } = this.props;
        return (React.createElement("button", { className: "header__dropdown-close", onClick: this.close, type: "button" },
            React.createElement(Icon, { modifiers: "#close-round", className: "header__dropdown-close-icon" }),
            React.createElement("span", { className: "sr-only" }, closeButtonLabel || labels.get('close'))));
    }
    render() {
        return (React.createElement(Transition, { in: this.state.isMounted && this.props.isShown, timeout: { enter: 10, exit: 100 }, mountOnEnter: true, unmountOnExit: true, onEntering: this.handleEnter, onExited: this.handleExited, onEntered: this.props.onTransitionEntered }, this.renderDropdown));
    }
}
HeaderDropdownInner.defaultProps = {
    size: 'large',
};
